import { axiosInstance } from '../../api';
const BASE_PATH = '/one_way_interview';

//Get All Custom Evaluation group API Call
export let getAllOneWayInterviewGroups = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_assigned_one_way_interview_groups');
        return value;
    } catch (error) {
        return error
    }
}

//Get All Custom Evaluation grouped candidates API Call
export let getAllOneWayInterviewGroupDetails = async (step_id) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_assigned_one_way_interviews_by_group',{
            step_id: step_id
        });
        return value;
    } catch (error) {
        return error
    }
}

//Get Single One-way Interview Task Details API Call
export let getOneWayInterviewTask = async (sessionID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_one_way_interview_task', {
            session_id: sessionID
        })
        return value;
    } catch (error) {
        return error
    }
}


export let submitOneWayInterviewReview = async (session_id, marks, comments_array, overallRating) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/submit_one_way_interview_review', {
            session_id: session_id,
            score: marks,
            comments: comments_array,
            overallRating: overallRating,
        });
        return value;
    } catch (error) {
        return error
    }
}


